/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "tailwindcss/base.css";
import "tailwindcss/components.css";
import "tailwindcss/utilities.css";
import { useLanguage } from "../../LanguageContext";
import translations from "../../translation_experience_footer";

function Experience() {
  const { language } = useLanguage();
  const t = translations[language];

  const experiences = t.experiences;

  return (
    <>
      <section
        id="experience"
        className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
        aria-label={t.experience}
      >
        {/* HUD Header */}
        {/* <div className="sticky top-0 z-20 -mx-6 mb-8 w-screen bg-[#021327]/90 px-6 py-5 backdrop-blur border-b border-cyan-500/20 md:-mx-12 md:px-12 lg:sr-only lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0">
          <h2 className="text-sm font-bold uppercase tracking-widest text-cyan-400 lg:sr-only flex items-center gap-2">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
            {t.experience}
          </h2>
        </div> */}

        {/* Timeline Container */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-4 top-0 bottom-0 w-px bg-gradient-to-b from-cyan-500 via-blue-500 to-cyan-500 opacity-30 md:left-6"></div>
          
          <ol className="space-y-8">
            {experiences.map((exp, index) => (
              <li key={index} className="relative">
                {/* Timeline Node */}
                <div className="absolute left-2 top-6 w-4 h-4 rounded-full border-2 border-cyan-400 bg-[#000C1A] z-10 md:left-4">
                  <div className="absolute inset-1 bg-cyan-400 rounded-full animate-pulse"></div>
                </div>

                {/* Experience Card */}
                <div className="ml-12 group relative md:ml-16">
                  <div className="relative bg-gradient-to-br from-slate-900/50 to-slate-800/30 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 hover:bg-gradient-to-br hover:from-slate-900/70 hover:to-slate-800/50">
                    
                    {/* HUD Corner Details */}
                    <div className="absolute top-2 right-2 flex gap-1">
                      <div className="w-1 h-1 bg-cyan-400 rounded-full opacity-60"></div>
                      <div className="w-1 h-1 bg-blue-400 rounded-full opacity-40"></div>
                      <div className="w-1 h-1 bg-cyan-400 rounded-full opacity-20"></div>
                    </div>

                    {/* Date Header */}
                    <header className="mb-4">
                      <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-500/10 border border-cyan-500/30 rounded-full">
                        <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full"></div>
                        <span className="text-xs font-mono uppercase tracking-wider text-cyan-300">
                          {exp.date}
                        </span>
                      </div>
                    </header>

                    {/* Title and Link */}
                    <h3 className="mb-3">
                      <a
                        className="group/link inline-flex items-center font-mono font-semibold text-lg text-slate-200 hover:text-cyan-300 transition-colors duration-200"
                        href={exp.link}
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label={`${exp.title} (opens in a new tab)`}
                      >
                        <span className="mr-2">{exp.title}</span>
                        <div className="relative overflow-hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-4 h-4 transition-transform duration-200 group-hover/link:translate-x-1 group-hover/link:-translate-y-1"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </a>
                    </h3>

                    {/* Description */}
                    <p className="text-slate-400 leading-relaxed text-sm font-mono">
                      {exp.description}
                    </p>

                    {/* Bottom HUD Line */}
                    <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent"></div>
                  </div>
                </div>
              </li>
            ))}
          </ol>
          {/* Resume Link - HUD Style */}
          <div className="mt-16 ml-12 relative">
            <div className="flex justify-start">
              <a
                className="group/resume relative inline-flex items-center gap-3 px-6 py-3 transition-all duration-300 text-white hover:text-cyan-300"
                href="/resume.pdf"
                target="_blank"
                rel="noreferrer noopener"
                aria-label={t.viewResume + " (opens in a new tab)"}
              > 
                <span className="font-mono">
                  {t.viewResume}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-4 h-4 transition-transform duration-200 group-hover/resume:translate-x-1 group-hover/resume:-translate-y-1"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default React.memo(Experience);